module.exports = __webpack_public_path__ + "media/metal_6.1c2c958b.webm";